module.exports = __webpack_public_path__ + "img/fat4.c787f8e5.png";